<template>
    <div id="app" v-infinite-scroll="load">
        <Header></Header>
        <router-view v-if="isLive&&$route.fullPath.indexOf('/center')<0" :key="$route.fullPath"/>
        <router-view v-else-if="isLive&&$route.fullPath.indexOf('/center')>=0"/>
        <MarginBtn></MarginBtn>
        <ChartRoom v-if="userInfo.detail"></ChartRoom>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from "@/components/Header";
    import Footer from "@/components/Footer";
    import MarginBtn from "@/components/MarginBtn";
    import ChartRoom from "@/components/ChartRoom"
    import {mapState} from 'vuex'

    export default {
        components: {Header, Footer, MarginBtn, ChartRoom},
        data() {
            return {
                isLive: true
            }
        },
        provide() {
            return {
                reLoad: this.reLoad
            }
        },
        created() {
            if (window.location.hostname === 'www.ly-house.com') {
                window.location.replace('/errpage/404.html')
            }
        },
        computed:{
            ...mapState(['userInfo'])
        },
        methods: {
            load() {
                this.$eventBus.$emit('onBottom')
            },
            reLoad() {
                this.isLive = false;
                this.$nextTick(() => {
                    this.isLive = true;
                })
            }
        }
    }
</script>

<style lang="less">
    html, body {
        width: 100%;
        height: 100%;
        padding: 0;
        margin: 0;
    }

    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
        height: 100%;
        width: 100%;
        overflow-y: auto;
    }
</style>
